const loader = (name: string) => async () => {
  const entrance = await import(/* webpackChunkName: "f.circle" */ './');
  return entrance[name];
};

import { IRoute } from '@src/types';

export const childRoutes: IRoute[] = [
  {
    load: loader('HomePage'),
    path: 'home-page/:groupId'
  },
  {
    load: loader('TopicInfoPage'),
    path: 'topic-info/:topicId'
  }
];
export default {
  path: 'group',
  name: 'group',
  childRoutes
};
